import { client } from "../../../api/client";

export const fetchQuoteTemplateByFilter = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require("./_local/_quoteTemplateData.json");
    } else {
        try {
          const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"templatesapi/quotetemplate/filter", body);
          return response.data;
        } catch (error) {
            console.error("Error fetching quote template:", error);
            return [];
        }
      }
}

export const deleteQuoteTemplate = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.delete(process.env.REACT_APP_GATEWAY_URI, `templatesapi/quotetemplate/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting quote template:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
};

export const createQuoteTemplate = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"templatesapi/quotetemplate", body);
        return response.data;
    } catch (error) {
        console.error("Error creating quote template:", error);
        return [];
    }
  } else {
    return { "data": { newId: Math.floor(Math.random() * 100000) } };
  }
};


export const updateQuoteTemplate = async (id, body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        const response = await client.put(process.env.REACT_APP_GATEWAY_URI,`templatesapi/quotetemplate/${id}`, body);
        return response.data;
    } catch (error) {
        console.error("Error updating quote template:", error);
        return [];
    }
  }
};

export const getAWSSettings = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, 'templatesapi/quotetemplate/getawssettings');
      return response.data;
    } catch (error) {
        console.error("Error getting AWS Settings:", error);
        return [];
    }
  }
};

export const getPreSignedUrl = async (key) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, 'templatesapi/quotetemplate/presignedurl/key', key);
      return response.data;
    } catch (error) {
        console.error("Error getting presigned url:", error);
        return [];
    }
  }
};

export const generateQuotePreview = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, 'templatesapi/quotetemplate/generatequotepreview', body);
      return response.data;
    } catch (error) {
        console.error("Error generating quote preview:", error);
        return [];
    }
  }
};

export const generateQuote = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, 'templatesapi/quotetemplate/generatequote', body);
      return response.data;
    } catch (error) {
        console.error("Error generating quote:", error);
        return null;
    }
  }
};